import { createContext } from 'react';

const FullscreenMainBlockContext = createContext(null);

export default FullscreenMainBlockContext;
